module.exports = __webpack_public_path__ + "img/icon-arrow-black.e8b3b79b.svg";